import React, { FC } from 'react';
import { useTemplatesContext } from '@components/Contexts/TemplatesContext';
import OneSelectionFilter from '@components/Templates/FilterPanel/OneSelectionFilter';
import { SITE_TYPES } from '@common/types';
import type { QueryParams } from '@common/types';

type Props = {};

const SiteTypeFilter: FC<Props> = ({}) => {
  const {
    state: { filters },
  } = useTemplatesContext();

  const createUpdatedQueryParam = (selectedItem?: string): QueryParams => ({
    siteType: selectedItem,
  });

  return (
    <OneSelectionFilter
      selectedValue={filters.siteType || SITE_TYPES.ALL}
      items={SITE_TYPES}
      langTokenPrefix={'marketplace.templates-page.site-type-'}
      createUpdatedQueryParam={createUpdatedQueryParam}
      dataHook={'site-type'}
    />
  );
};

export default SiteTypeFilter;
